<script>
  import { app } from "./lib/firebase";
  import {
    getAuth,
    signInAnonymously,
    onAuthStateChanged,
  } from "@firebase/auth";
  import NeomorphicForm from "./Components/NeomorphicForm.svelte";

  let uid = null;
  let signedIn = false;

  const auth = getAuth(app);
  onAuthStateChanged(auth, (user) => {
    if (user) {
      uid = user.uid;
    }
  });

  signInAnonymously(auth).then((userData) => {
    signedIn = userData;
  });
</script>

<main class="bg-eventLinkBackground">
  <NeomorphicForm />
</main>

<style global>
  @tailwind base;
  @tailwind components;
  @tailwind utilities;

  main {
    background-color: #ebecf0;
  }
</style>
